import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "All",
  search: "",
};

const filtersSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    changeStatusFilter: (state, action) => {
      state.status = action.payload;
    },
    searchChangeFilter: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { changeStatusFilter, searchChangeFilter } = filtersSlice.actions;
export default filtersSlice.reducer;
